import { useSyncExternalStore } from "react"
import { canControlVolume } from "app/player/utils/canControlVolume"

const subscribe = () => () => {}

/** True when HTMLMediaElement.volume changes audible output (false on iOS). */
export default function useCanControlVolume() {
  return useSyncExternalStore(subscribe, canControlVolume, () => true)
}
